import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { rejectRefund } from '../refundsEndpoints'
import { refundKeys } from '../refundsQueryKeys'
import { fiatTransactionKeys } from '../../../fiatTransactions/api/fiatTransactionsQueryKeys'
import type { RejectRefundInput } from '../../types/refundsTypes'

export function useRejectRefundMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: RejectRefundInput) => rejectRefund(input),
    onSuccess: (_, vars) => {
      qc.invalidateQueries({ queryKey: refundKeys.lists() })
      qc.invalidateQueries({ queryKey: refundKeys.statusCounts() })
      qc.invalidateQueries({ queryKey: refundKeys.detail(vars.id) })
      qc.invalidateQueries({ queryKey: fiatTransactionKeys.lists() })
    },
  })
}
